import templateStr from 'text!./templates/policy-common-coverables.html';
import _ from 'underscore';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            'policy': '=',
            'period': '='
        },

        controller: ['$stateParams', 'PolicyService', '$scope', function ($stateParams, PolicyService, $scope) {
            $scope.coverables = $scope.policy.coverables;
            if (angular.isDefined($scope.period)) {
                $scope.coverables = $scope.period.coverables;
            }
            $scope.policyNumber = $stateParams.policyNumber;
            /**
             * service call to get the MSF portal host for MSF elective link and coverage levels
             */
            $scope.msfHost = PolicyService.getMsfPortalHost();
            $scope.msfHost.then(function (data) {
                $scope.MSFElectiveLink = data + '/web/workerscompensation/exemptemployers.jsf';
                $scope.MSFCoverageLevels = data + '/web/docs/minandmaxcoverage.pdf';
            }, function (err) {
                console.error('Error while retrieving MSF host: ', err);
            });

            /**
             * CR #16787 - Added this method to get only 10 class codes to improve performance.
             **/
            PolicyService.searchWCCoveredEmployees_Ext($scope.policy.policyNumber, undefined, 10).then(function (employeeData) {
                $scope.policy.coverables[0].coverages[0].mSFWCCoveredEmployees = employeeData;
            });
            /**
             * Call to check for existing Waivers
             */
            var WOSExist = PolicyService.getExistingWOS($stateParams.policyNumber);
            WOSExist.then(function (res) {
                $scope.wos = res;
                $scope.wos.forEach(function (value) {
                    $scope.addToCoverage(value);
                });
            }, function () {
                $scope.wosArray = {};
                $scope.isWosExist = false;
            });

            $scope.addToCoverage = function (wos) {
                $scope.coverables = $scope.period.coverables;
                if (wos.wosType == "Blanket") {
                    wos.name = "Blanket Waiver Of Subrogation";
                    wos.companyName = "";
                    wos.addressLine1 = "";
                    wos.city = "";
                    wos.state = "";
                    wos.postalCode = "";
                } else {
                    wos.name = "Specific Waiver Of Subrogation";
                }
                // $scope.coverables[0].coverages = $scope.wos;
                wos.msfCoverageType_EXT = "Electable";
                var existingRecords = _.where($scope.coverables[0].coverages, { companyName: wos.companyName, postalCode: wos.postalCode });
                if (existingRecords.length == 0) {
                    $scope.coverables[0].coverages.push(wos);
                }
            };

            $scope.removeLocNumber = function (locString) {
                if (locString.indexOf(':')) {
                    locString = locString.substring(locString.indexOf(':') + 1);
                }
                return locString;
            };
            /**
             * Method to redirect to Elective Endorsement list when click on elective link
             * @param ("policyNumber", "policyNumber which has been initiated from portal")
             * @return ("String")
             */
            $scope.electiveLink = function (e) {
                e.stopPropagation();
                PolicyService.callEUTS('Policy Details', 'Elective Endorsements List', $stateParams.policyNumber);
            };

            $scope.levelsLink = function (e) {
                e.stopPropagation();
                PolicyService.callEUTS('Policy Details', 'Coverage Levels Available Link', $stateParams.policyNumber);
            };

            /**
             * Conditions to merge all owners and officers details and push them to single array
             */
            if ($scope.coverables[0].coverages[0].mSFWCOwnersOfficers_EXT.length > 0) {
                $scope.allOwnersOfficers = [];
                angular.forEach($scope.coverables[0].coverages[0].mSFWCOwnersOfficers_EXT, function (ownerOfficer) {
                    angular.forEach(ownerOfficer.policyOwnerDetail, function (policyOwnerDetail) {
                        $scope.allOwnersOfficers.push(policyOwnerDetail);
                    });
                });

                sortOwnersAndOfficers();
            }

            /**
             * Private method to sort Owners and Officer by company and expiration date
             */
            function sortOwnersAndOfficers() {
                splitAndSortOwnersByCompany();
                splitandSortOwnersByExpiration();
            }

            /**
             * Method to Split and sort the Owner details based on the company and person
             */
            function splitAndSortOwnersByCompany() {
                var companyOwners = [];
                var personOwners = [];
                angular.forEach($scope.allOwnersOfficers, function (ownerOfficer) {
                    if (ownerOfficer.lastName === undefined) {
                        companyOwners.push(ownerOfficer);
                    } else {
                        personOwners.push(ownerOfficer);
                    }
                });
                companyOwners = companyOwners.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
                personOwners = personOwners.sort(function (a, b) {
                    return getOwnerSortName(a).localeCompare(getOwnerSortName(b));
                });
                $scope.allOwnersOfficers.length = 0;
                [].push.apply($scope.allOwnersOfficers, personOwners);
                [].push.apply($scope.allOwnersOfficers, companyOwners);
            }

            /**
             * Private method to Split and sort Owners based on the expiration date
             * if owner's expiration date is undefined then push them to current owner
             * if owner's expiration is exist then push them to expired owners array
             */
            function splitandSortOwnersByExpiration() {
                var currentOwners = [];
                var expiredOwners = [];
                angular.forEach($scope.allOwnersOfficers, function (ownerOfficer) {
                    if (ownerOfficer.expirationDate === undefined) {
                        currentOwners.push(ownerOfficer);
                    } else {
                        expiredOwners.push(ownerOfficer);
                    }
                });
                $scope.allOwnersOfficers.length = 0;
                [].push.apply($scope.allOwnersOfficers, currentOwners);
                [].push.apply($scope.allOwnersOfficers, expiredOwners);
            }

            function getOwnerSortName(ownerOfficer) {
                return ownerOfficer.lastName + ' ' + ownerOfficer.firstName;
            }

            /**
             * Conditions to merge all class code's basis amount if there is a Split
             * For split policy, sum all covered employee's basis
             */
            if ($scope.coverables[0].coverages[0].mSFWCCoveredEmployees.length > 0 && $scope.coverables[0].coverages[0].mSFAddWCCoveredEmployees.length > 0) {
                $scope.allClassCodes = [];
                angular.forEach($scope.coverables[0].coverages[0].mSFWCCoveredEmployees, function (allVersions) {
                    angular.forEach($scope.coverables[0].coverages[0].mSFAddWCCoveredEmployees, function (additionalVersions) {
                        // DEF2105-Display Isue : For split policy , sum of  Covered employee's basis is not showing correctly in Covered employee's section in Policy summary screen.
                        if (!allVersions.basisCalc && allVersions.classCode == additionalVersions.classCode && allVersions.location == additionalVersions.location) {
                            allVersions.basisAmount += additionalVersions.basisAmount;
                            allVersions.basisCalc = true;
                        }
                    });
                    $scope.allClassCodes.push(allVersions);
                });
            }

            $scope.searchRequest = {
                searchParam: ''
            };

            /**
             * CR #16787 - Added this method to search class codes.
             **/
            $scope.filterCondition = function (filterParam) {
                if (filterParam.length !== 0 && filterParam.length < 3) {
                    $scope.showErr = true;
                    return;
                } else {
                    $scope.showErr = false;
                }
                PolicyService.searchWCCoveredEmployees_Ext($scope.policy.policyNumber, filterParam, 10).then(function (employeeData) {
                    $scope.policy.coverables[0].coverages[0].mSFWCCoveredEmployees = employeeData;
                });
            };

            /**
             * Method to check each coverage's coverage type 
             * return {boolean}
             */
            $scope.NonMandatoryAvailability = function (coverables) {
                $scope.nonmandatory = false;
                angular.forEach(coverables, function (coverable) {
                    // checking Each Coverage
                    angular.forEach(coverable.coverages, function (coverage) {
                        if (coverage.msfCoverageType_EXT === 'Electable' || coverage.msfCoverageType_EXT === 'Suggested') {
                            $scope.nonmandatory = true;
                        }
                    });
                });
                return $scope.nonmandatory;
            };
            /**
             * Method to format the basis amount into currency format 
             */
            $scope.createAmountFormat = function (basisamount) {
                return { amount: basisamount, currency: 'usd' };
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policy/common/directives/PolicyCommonCoverables.js
// module id = 2073
// module chunks = 0